import React, { Component } from 'react';
import Select from 'react-select';


import Dialog from '../../../commonModules/interface/Dialog';
import PopUp from '../../../commonModules/interface/PopUp';
import { Grid, List, ListItem, ListSubheader } from '@material-ui/core';
import { InputSelectMagasin } from '../../../commonModules/interface/form-input-inline';

class FormUpdateRole extends Component {
    state = {  }
    render() {
        return (
            <PopUp 
                title="Modifier la liste des pages"
                block={true}
                close={this.props.handleClose}
                submitAction={this.props.handleSubmit}
                submitTitle="Modifier le role"
            >                
                <Grid container spacing={2}>
                    <Grid item xs={12} md={4} >
                        {/* <div className={"form-group col-sm-12 "+(this.props.errors.role ? "has-error" : "")}>
                            <label className="control-label">Role à modifier</label> 
                            <Select
                                options={this.props.roleList}
                                className="form-control"
                                value={this.props.roleDisplay}
                                placeholder="Choisissez un Role"
                                onChange={(option) => this.props.handleSelect(option, "role")}
                                style={{border: '0'}}
                                // selectedValue={this.props.role}
                            />
                            <small className="help-block">{this.props.errors.role}</small>
                        </div> */}
                        <InputSelectMagasin
                            options={this.props.roleList}
                            value={this.props.roleDisplay}
                            placeholder="Choisissez un Role"
                            onChange={(option) => this.props.handleSelect(option, "role")}
                            label="Role à Modifier"
                            error={this.props.errors.role}
                        />
                        { this.props.role && 
                            <p>
                                {/* <i>Liste actuelle</i> */}
                                <List className="list-group"
                                    subheader={
                                        <ListSubheader component="div" id="nested-list-subheader">
                                            Liste actuelle
                                        </ListSubheader>
                                    }
                                >
                                    {
                                        this.props.roleDisplay.access.map( page =>(
                                            <ListItem className="list-group-item">{page}</ListItem>
                                        ))
                                    }
                                </List>
                            </p>
                        }
                    </Grid>
                    <Grid item xs={12} md={8} >
                        {/* <div className={"form-group col-sm-12 "+(this.props.errors.pages ? "has-error" : "")}>
                            <label className="control-label">Accès Pages</label>  
                            <Select
                                value={this.props.pages}
                                onChange={pages => this.props.handleSelectPage(pages)}
                                options={this.props.pageSelect}
                                isMulti
                                closeMenuOnSelect={false}
                                closeOnSelect={false}
                                components={makeAnimated()}
                            />
                            <small className="help-block">{this.props.errors.pages}</small>
                        </div>                                                 */}
                            <InputSelectMagasin
                                value={this.props.pages}
                                onChange={pages => this.props.handleSelectPage(pages)}
                                options={this.props.pageSelect}
                                isMulti
                                label="Accès Page"
                                closeMenuOnSelect={false}
                                closeOnSelect={false}
                                error={this.props.errors.pages}
                                // components={makeAnimated()}
                            />
                    </Grid>
                </Grid>                    
            </PopUp>
        );
    }
}

export default FormUpdateRole;